const applySameStyling = (editor,setAnchorApplyStylingEl) => {

    editor.Commands.add("command-apply-same-styling", {
        run() {
          const commands = editor.Commands;     
          if(commands.isActive('view-annotations') === false){
            const palleteElement = document.querySelectorAll('[data-tooltip="Apply styling"')[0];
            setAnchorApplyStylingEl(palleteElement);
          }
        }
      });
}

export default applySameStyling;